import { Avatar, Box, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { AutocompleteInput, Link, ReferenceInput, TextInput, useInput } from "react-admin";
import dataProvider from "../providers/grapheneDataProvider2";

const ProductSelectionFilter = (searchText: string) => {
  if (!searchText) return {};
  if (searchText.startsWith("prod_")) {
    return { productId__icontains: `${searchText}` };
  } else if (searchText.startsWith("price_")) {
    return { price_id__istartswith: `${searchText}` };
  }
  return {
    name__icontains: `${searchText}`,
  };
};

interface Product {
  image: string;
  name: string;
  productId: string;
}

const ProductSelectionInputWithPreview = ({
  source = "products.productId",
  disabled = false,
  value = "",
  resource = "v2Products",
}) => {
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);

  const { field } = useInput({ source });

  useEffect(() => {
    if (field.value) {
      dataProvider
        .getOne(resource, { id: field.value, fields: "productId image" })
        .then(({ data }: any) => {
          console.log(data, "data provided");
          setSelectedProduct(data);
        })
        .catch((err) => console.error(err));
    }
  }, [field.value]);

  return value ? (
    <TextInput source="" defaultValue={value} disabled />
  ) : (
    <ReferenceInput
      label="Product"
      source={source}
      reference={resource}
      enableGetChoices={({ q }) => q && q.length >= 2}
      disabled={disabled}
    >
      <>
        {selectedProduct && selectedProduct.image ? (
          <Tooltip
            title={`View product ↗ (opens in new tab)`}
            slotProps={{
              popper: {
                modifiers: [
                  {
                    name: "offset",
                    options: {
                      offset: [0, -14],
                    },
                  },
                ],
              },
            }}
          >
            <Box display="flex" alignItems="center" mt={2}>
              <Link
                to={`/${resource}/${selectedProduct.productId}${resource == "v2Products" ? "/show" : ""}`}
                target="_blank"
              >
                <Avatar
                  src={selectedProduct.image}
                  alt={selectedProduct.name}
                  sx={{ width: 50, height: 50, marginRight: 2 }}
                />
              </Link>
            </Box>
          </Tooltip>
        ) : (
          <Box display="flex" alignItems="center" mb={2} sx={{ width: 50, height: 50, marginRight: 2 }} />
        )}
        <AutocompleteInput
          label="Product"
          helperText="Lookup products by their name &amp; ID, or by price ID"
          inputText={(option) => `${option.name} \n [${option.id}]`}
          optionText={(option) => `${option.name} \n [${option.id}]`}
          filterToQuery={ProductSelectionFilter}
          sx={{ width: "80%" }}
        />
      </>
    </ReferenceInput>
  );
};

export default ProductSelectionInputWithPreview;
